import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import performanceApi from '~/pages/Dashboard/AnalyticsBox/reports/Performance/performance.api';
import { requestStarted, requestFinished } from '~/stores/redux/common/loadingSlice';
import { handleThunkException } from '~/services/thunk.service';

export const fetchPerformanceApi = createAsyncThunk(
    'dashboard/performance/fetchPerformanceApi',
    async (navigate, { dispatch }) => {
        try {
            dispatch(requestStarted());
            const data = await performanceApi.getAll();
            if (data) {
                dispatch(requestFinished());
                return data;
            }
        } catch (error) {
            handleThunkException(error, dispatch, navigate);
        }
    },
);

export const performanceSlice = createSlice({
    name: 'dashboard/performance',
    initialState: { playerSignedUp: {}, gamesPlayed: {}, matchmakingDuration: {}, consecutiveGames: {} },
    extraReducers: (builder) => {
        builder.addCase(fetchPerformanceApi.fulfilled, (state, action) => {
            Object.assign(state, action.payload);
        });
    },
});

export const { getPerformanceData } = performanceSlice.actions;
